import { ArrowUpRight, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";
import { LocalizedLink } from "../../lib/i18nRouting";
import Reveal from "../Reveal";

export default function FinalCTA() {
  const { t } = useTranslation();
  return (
    <section className="bg-forest text-bone py-32 lg:py-48 relative overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0 grain" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 text-center md:text-left">
        <Reveal>
          <div className="text-xs uppercase tracking-wider-3 text-bone/70 mb-6 inline-flex items-center gap-3">
            <span className="inline-block w-8 h-px bg-bone/60" />
            {t("final_cta.eyebrow")}
          </div>
        </Reveal>
        <Reveal delay={120}>
          <h2 className="font-display text-6xl md:text-8xl lg:text-9xl leading-[0.95] max-w-5xl">
            {t("final_cta.title_a")} <span className="italic">{t("final_cta.title_b")}</span>?
          </h2>
        </Reveal>

        <Reveal delay={250} className="mt-16 flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-start justify-center">
          <LocalizedLink
            to="/rezervare"
            data-testid="final-cta-book"
            className="btn-lift inline-flex items-center justify-center gap-3 bg-bone text-forest px-8 py-4 text-xs uppercase tracking-wider-3 hover:bg-bone-deep"
          >
            {t("final_cta.cta_book")} <ArrowUpRight className="w-4 h-4" />
          </LocalizedLink>
          <LocalizedLink
            to="/contact"
            data-testid="final-cta-contact"
            className="btn-lift inline-flex items-center justify-center gap-3 border border-bone/60 px-8 py-4 text-xs uppercase tracking-wider-3 hover:bg-bone hover:text-forest"
          >
            {t("final_cta.cta_contact")}
          </LocalizedLink>
          <a
            href="tel:0752354222"
            data-testid="final-cta-phone"
            className="inline-flex items-center justify-center gap-2 text-sm text-bone/85 link-underline mt-2 sm:mt-0 sm:ml-4"
          >
            <Phone className="w-4 h-4" /> 0752 354 222
          </a>
        </Reveal>
      </div>
    </section>
  );
}
